'use client'

import * as React from 'react'

import { Backdrop, Box, Slide, useTheme } from '@mui/material'

import { MegaMenuContent } from '@/components/MegaMenu/MegaMenuContent'
import { useHeaderContext } from '@/hooks/useHeaderContext'

import type { FC } from 'react'
import type { TopNavigationNode } from '@/interfaces/NavigationNode'

interface MegaMenuProps {
  window?: () => Window
  navigation: TopNavigationNode[]
}

export const MegaMenu: FC<MegaMenuProps> = ({ navigation }) => {
  const { toggleIsMegaMenuOpen, forceClose, headerAppBarRef, isMegaMenuOpen } = useHeaderContext()
  const theme = useTheme()
  const [containerElement, setContainerElement] = React.useState<HTMLElement | null>(null)
  const [headerHeight, setHeaderHeight] = React.useState<number>(0)

  React.useEffect(() => {
    if (headerAppBarRef.current) {
      setContainerElement(headerAppBarRef.current)
      setHeaderHeight(headerAppBarRef.current.getBoundingClientRect().height)
    }
  }, [headerAppBarRef])

  if (navigation.length === 0) {
    return null
  }

  return (
    <>
      <Backdrop open={isMegaMenuOpen} sx={{ zIndex: theme.zIndex.appBar - 1 }} />
      <Slide
        container={containerElement}
        timeout={{
          enter: theme.transitions.duration.short,
          exit: theme.transitions.duration.short,
        }}
        in={isMegaMenuOpen}
        onMouseOver={toggleIsMegaMenuOpen(!forceClose)}
        onMouseLeave={toggleIsMegaMenuOpen(false)}
      >
        <Box
          sx={{
            position: 'absolute',
            bgcolor: theme.palette.background.default,
            width: '100%',
            zIndex: theme.zIndex.appBar - 1,
            minHeight: headerHeight,
          }}
        >
          <MegaMenuContent navigation={navigation} />
        </Box>
      </Slide>
    </>
  )
}
